import React from 'react';
import TextInput from './TextInput';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';

export default function TextSearchInput(props) {
  const {
    inputProps = {},
  } = props;
  const { onChange = () => {}, name = '' } = inputProps;
  const clear = event => {
    onChange({ target: { value: '', name } });
    event.stopPropagation();
  };
  return (
    <TextInput
      inputBefore={(
        <div className="search-wrapper">
          <Icons customIcon className="search" width={24} height={24} icon="search" />
        </div>
      )}
      inputAfter={(
        <div className="search-wrapper cursor-pointer" onClick={clear}>
          <Icons customIcon className="search" width={18} height={18} icon="close" />
        </div>
      )}
      {...props}
      inputProps={{ ...(props?.inputProps || {}), name: props?.inputProps?.name || 'search' }}
    />
  );
}
